import { render, staticRenderFns } from "./SeparateList.vue?vue&type=template&id=3ff5cb2e&scoped=true"
import script from "./SeparateList.vue?vue&type=script&lang=ts"
export * from "./SeparateList.vue?vue&type=script&lang=ts"
import style0 from "./SeparateList.vue?vue&type=style&index=0&id=3ff5cb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff5cb2e",
  null
  
)

export default component.exports